/*
  Pinned-first collection cards.
  /collections/all?first=<product-handle>&variant=<variant-id>
  puts that product (showing that variant's image) in slot #1 of page 1.

  `first` may also be a full product URL, e.g. Meta's encoded {{product.url}}:
  ?first=https%3A%2F%2Fcaskandcotton.com%2Fproducts%2F<handle>%3Fvariant%3D<id>
  The handle and variant are pulled out of it. Catalog items carry their
  variant in that URL, so catalog ads need nothing extra.

  For hand-built links, name the color instead of looking up a variant id:
  ?first=<handle>&color=navy   (case and spaces/hyphens don't matter)

  If the product is already on the page it moves to the top. Otherwise the last
  card is dropped, so the page keeps its 16 and the grid stays even.
*/
(function () {
  var params = new URLSearchParams(window.location.search);
  var first = params.get('first');
  if (!first) return;
  if (parseInt(params.get('page') || '1', 10) > 1) return;

  var variant = params.get('variant');
  if (first.indexOf('/products/') !== -1) {
    try {
      var u = new URL(first, window.location.origin);
      var m = u.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) first = m[1];
      if (!variant) variant = u.searchParams.get('variant');
    } catch (e) {
      return;
    }
  }
  first = decodeURIComponent(first).trim().toLowerCase();
  if (!/^[a-z0-9][a-z0-9-]*$/.test(first)) return;
  if (variant && !/^\d+$/.test(variant)) variant = null;

  var grid = document.getElementById('product-grid');
  if (!grid) return;
  var items = grid.querySelectorAll(':scope > li.grid__item');
  if (!items.length) return;

  // Match the grid's card shape (portrait / square / adapt), whatever the
  // collection is set to, so one card template covers every layout.
  var gridInner = items[0].querySelector('.card__inner');
  var gridRatio = gridInner ? gridInner.style.getPropertyValue('--ratio-percent') : '';

  // Hold slot #1 straight away so the grid doesn't jump when the card arrives.
  var placeholder = items[0].cloneNode(true);
  placeholder.style.visibility = 'hidden';
  placeholder.removeAttribute('data-cascade');
  placeholder.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
  grid.insertBefore(placeholder, items[0]);
  var dropped = items[items.length - 1];
  dropped.remove();

  function undo() {
    placeholder.remove();
    grid.appendChild(dropped);
  }

  // ?color=navy -> the first variant (smallest size) in that color.
  var color = (params.get('color') || '').toLowerCase().replace(/[-_+]/g, ' ').trim();
  function norm(s) { return String(s || '').toLowerCase().replace(/[-_]/g, ' ').trim(); }
  var findVariant = (!variant && color)
    ? fetch('/products/' + first + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return null;
          var hit = p.variants.filter(function (v) {
            return v.options.some(function (o) { return norm(o) === color; });
          })[0];
          return hit ? String(hit.id) : null;
        })
        .catch(function () { return null; })
    : Promise.resolve(variant);

  findVariant
    .then(function (v) {
      return fetch('/products/' + first + '?view=card' + (v ? '&variant=' + v : ''), { credentials: 'same-origin' });
    })
    .then(function (r) { return r.ok ? r.text() : null; })
    .then(function (html) {
      if (!html) return undo();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var card = doc.getElementById('pinned-card');
      if (!card) return undo();

      // Already on this page: remove it there, and give back the card we dropped.
      var dupes = [];
      grid.querySelectorAll('a[href*="/products/' + first + '"]').forEach(function (a) {
        var li = a.closest('li.grid__item');
        if (li && li !== placeholder && dupes.indexOf(li) === -1) dupes.push(li);
      });
      if (dupes.length) {
        dupes.forEach(function (li) { li.remove(); });
        grid.appendChild(dropped);
      }

      // Show the ad's variant: its image on the card, and links that open on it.
      var vid = card.getAttribute('data-variant-id');
      var vsrc = card.getAttribute('data-variant-src');
      if (vsrc) {
        var img = card.querySelector('.card__media img');
        if (img) {
          img.removeAttribute('srcset');
          img.removeAttribute('loading');
          img.src = vsrc;
        }
      }
      if (vid) {
        card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          var link = new URL(a.getAttribute('href'), window.location.origin);
          link.searchParams.set('variant', vid);
          a.setAttribute('href', link.pathname + link.search);
        });
      }

      if (gridRatio) {
        card.querySelectorAll('.card__inner, .card--media').forEach(function (el) {
          if (el.style.getPropertyValue('--ratio-percent')) el.style.setProperty('--ratio-percent', gridRatio);
        });
      }

      var li = document.createElement('li');
      li.className = 'grid__item grid__item--pinned';
      while (card.firstChild) li.appendChild(card.firstChild);
      grid.replaceChild(li, placeholder);
    })
    .catch(undo);
})();